module.exports = __webpack_public_path__ + "img/11.d352bf05.png";